import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { InternetProduct, WifiModel } from '@dch/products-business-logic';
import { Store } from '@ngrx/store';
import {
  ApplicationState,
  getWifiInformationPending,
  getWifiInformationTechnicalError,
  getWifiPrivateAccess24Ghz,
} from '../../../../store/reducers';
import { GetWifiInformation } from '../../../../store/actions/wifi-information.actions';
import { OnDestroyHookDirective } from '../../../../shared/hooks';
import { TranslationService } from '@proximus/ng-common';

@Component({
  selector: 'mprd-wifi-credentials',
  templateUrl: './wifi-credentials.component.html',
})
export class WifiCredentialsComponent
  extends OnDestroyHookDirective
  implements OnChanges, OnInit
{
  @Input() product: InternetProduct;

  wifi: WifiModel;
  isPending = false;
  hasError = false;
  showPassword = false;

  constructor(
    private store: Store<ApplicationState>,
    private translationService: TranslationService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.addSubscription(
      this.store.select(getWifiPrivateAccess24Ghz).subscribe((value) => {
        this.wifi = value;
      }),
    );

    this.addSubscription(
      this.store.select(getWifiInformationTechnicalError).subscribe((value) => {
        this.hasError = !!value;
      }),
    );

    this.addSubscription(
      this.store.select(getWifiInformationPending).subscribe((value) => {
        this.isPending = value;
      }),
    );
  }

  ngOnChanges(changes: SimpleChanges) {
    const previousValue = <InternetProduct>changes['product'].previousValue;
    if (
      this.product?.accessNumber &&
      this.product.accessNumber !== previousValue?.accessNumber
    ) {
      this.store.dispatch(
        new GetWifiInformation({ circuitId: this.product.accessNumber }),
      );
    }
  }

  goToEditWifiSetting() {
    localStorage.setItem('circuitId', this.product.accessNumber);
    window.location.assign(
      this.translationService.getTranslatedValueFor(
        'internet.wifiCredentials.editWifiSetting.url',
      ),
    );
  }
}
